import React, { useContext } from 'react';
import { SearchContext } from '../SearchComponent/context/SearchContext';

const SearchResultInfo = () => {
  const { t, currentSearchCategory, totalSearchResultsCount } = useContext(SearchContext);

  return (
    <>
      <div className="search-category">{currentSearchCategory}</div>
      <div className="search-results-nb">
        {t('resultsSummary').replace('{0}', totalSearchResultsCount)}
      </div>
    </>
  );
};

export default SearchResultInfo;
